import {
  MotifModal,
  MotifModalBody,
  MotifModalFooter,
} from "@ey-xd/motif-react";
import "./DeleteOrderModal.scss";
import { useDispatch } from "react-redux";
import { AppDispatch } from "../../../store";
import { deleteOrderBundle } from "../../../store/slices/CheckoutSlice";
import Button from "../../Button/Button";
import { CANCEL_BUTTON_TEXT } from "../../../Constant";
import { useEffect } from "react";

type Props = {
  isVisible: boolean;
  popupCloseHandler: () => void;
  orderId: string;
};

export default function DeleteOrderModal({
  isVisible,
  popupCloseHandler,
  orderId,
}: Props) {
  const dispatch = useDispatch<AppDispatch>();
  const handleClose = () => {
    popupCloseHandler();
  };

  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = "hidden";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isVisible]);

  const deleteBtnHandler = async () => {
    const OrderUpdateobj = {
      Action: "deleteOrder",
      OrderId: Number(orderId),
    };
    try {
      const response = await dispatch(deleteOrderBundle(OrderUpdateobj));
      if (response.meta.requestStatus === "fulfilled") {
        popupCloseHandler();
      } else {
        console.error("Failed to update order:", response.payload.message);
      }
    } catch (error) {
      console.error("Error deleting product:", error);
    }
  };

  return (
    <>
      <MotifModal
        className={`DeleteOrderModal ${name} `}
        onClose={handleClose}
        show={isVisible}
        focusTrapOptions={{
          tabbableOptions: {
            displayCheck: "none",
          },
        }}
      >
        <div className="DeleteOrderModalModelWrapper">
          <MotifModalBody>
            <div className="discard_message">
              <p>{`Are you Sure you want to Delete this Order Bundle ?`}</p>
              <p className="suggestion-text">
                This order bundle will be permanently removed, and cannot be
                recovered.
              </p>
            </div>
          </MotifModalBody>
          <MotifModalFooter>
            <Button
              label={CANCEL_BUTTON_TEXT}
              variant={"primary"}
              className="cancelBtnModal"
              onClickHandler={handleClose}
            />
            <Button
              label={"Delete"}
              variant={"secondary"}
              className="deleteBtnModal"
              onClickHandler={deleteBtnHandler}
            />
          </MotifModalFooter>
        </div>
      </MotifModal>
    </>
  );
}
